import React from 'react';
import ReactAnimateHeight from 'react-animate-height';

import './AnimateHeight.scss';

const AnimateHeight = ({ children, height, duration }) => (
  <ReactAnimateHeight
    // id="example-panel"
    duration={duration || 500}
    height={height} // see props documentation below
  >
    {children || ''}
  </ReactAnimateHeight>
);

export default AnimateHeight;
